import { useState } from 'react';
import Input from '../uikit/Input/Input';

const TestQuillEditor = () => {
  const [quillValue, setQuillValue] = useState('');
  const [rteValue, setRteValue] = useState('');

  return (
    <div style={{ padding: '20px', display: 'flex', gap: '40px' }}>
      <div style={{ flex: 1 }}>
        <h2>New Quill Editor</h2>
        <Input
          type='text-editor-quill'
          name='quill-test'
          value={quillValue}
          onChange={setQuillValue}
          label='Quill Editor Test'
          placeholder='Type something here...'
          max={500}
          symbolsCountText={`${quillValue ? quillValue.replace(/<[^>]*>/g, '').length : 0}/500`}
        />
        <div style={{ marginTop: '20px' }}>
          <h4>Raw HTML Output:</h4>
          <pre style={{ background: '#f5f5f5', padding: '10px', borderRadius: '4px', whiteSpace: 'pre-wrap' }}>
            {quillValue}
          </pre>
        </div>
      </div>

      <div style={{ flex: 1 }}>
        <h2>Old RTE Editor (for comparison)</h2>
        <Input
          type='text-editor-quill'
          name='rte-test'
          value={rteValue}
          onChange={setRteValue}
          label='RTE Editor Test'
          placeholder='Type something here...'
          max={500}
        />
      </div>
    </div>
  );
};

export default TestQuillEditor;
